/**
 * Construct WebSocket URL from API URL
 * Handles different deployment scenarios (local dev, staging, production)
 * 
 * @returns {string} WebSocket base URL
 */
export function getWebSocketUrl() {
  const apiUrl = import.meta.env.VITE_API_URL

  // In local dev with Vite dev server (port 3001), use Vite's proxy
  // This ensures cookies and auth headers are sent correctly
  if (window.location.port === '3001') {
    return 'ws://localhost:3001'
  }

  // If apiUrl is a relative path (e.g., '/api'), use window.location to build absolute URL
  if (apiUrl && !apiUrl.startsWith('http')) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const host = window.location.host
    // Don't include /api suffix since we'll add the full path later
    return `${protocol}//${host}`
  }

  // If apiUrl is absolute (e.g., 'http://localhost:8081'), convert to WebSocket URL
  if (apiUrl && apiUrl.startsWith('http')) {
    // Replace http/https with ws/wss and return the base URL
    // Remove /api suffix if present since we'll add the full path later
    return apiUrl.replace(/^http/, 'ws').replace(/\/api$/, '')
  }

  // Default for local development (no /api in base URL)
  return 'ws://localhost:8081'
}
